import * as O from 'fp-ts/Option'
import { pipe } from 'fp-ts/function'

export type baseLayoutType = 'responsive' | 'mobile'
export type mobileDeviceLayoutType = 'smartphone' | 'tablet'
export type fullLayoutCalcType = 'responsive' | 'smartphone' | 'tablet'

export const SMARTPHONE_TABLET_THRESHOLD = 425
export const TABLET_RESPONSIVE_THRESHOLD = 768
export const DESKTOP_SCREEN_THRESHOLD = 1024
export const HD_SCREEN_THRESHOLD = 1600
export const FULLHD_SCREEN_THRESHOLD = 1920

export const layoutDocumentTypeCalculator = () => layoutTypeCalculator(document.documentElement.clientWidth)

export function layoutTypeCalculator(width: number): baseLayoutType {
    return pipe(
        width,
        O.fromPredicate<number>(w => w <= TABLET_RESPONSIVE_THRESHOLD),
        O.match(
            () => 'responsive',
            _ => 'mobile'
        )
    )
}

export const layoutDeviceTypeCalculator = () => layoutDeviceThresholdCalculator(document.documentElement.clientWidth)

export function layoutDeviceThresholdCalculator(width: number): mobileDeviceLayoutType {
    return pipe(
        width,
        O.fromPredicate<number>(w => w <= SMARTPHONE_TABLET_THRESHOLD),
        O.match(
            () => 'tablet',
            _ => 'smartphone'
        )
    )
}

export const fullLayoutTypeCalculator = (): fullLayoutCalcType => {
    const width = document.documentElement.clientWidth
    return width >= TABLET_RESPONSIVE_THRESHOLD ? 'responsive' : layoutDeviceThresholdCalculator(width)
}
